/**
 * OVERRIDE View.jsx
 * REASON: Use align:noprefix and blockWidth:noprefix CSS custom properties instead of align class.
 * DATE: 2026-04-16
 * DEVELOPER: @danalvrz
 */

import VideoView from '../../../../../../components/Blocks/Video/View';

export default VideoView;
